import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";

// ── PDF ──────────────────────────────────────────────────────
export function exportPDF(title, columns, rows) {
  const doc = new jsPDF({ orientation: "landscape" });
  doc.setFontSize(14);
  doc.text(title, 14, 15);
  autoTable(doc, {
    startY: 22,
    head: [columns],
    body: rows,
    headStyles: { fillColor: [45, 74, 198], textColor: 255, fontStyle: "bold" },
    styles: { fontSize: 9, cellPadding: 3 },
    alternateRowStyles: { fillColor: [245, 245, 245] },
  });
  doc.save(`${title}.pdf`);
}

// ── Excel (CSV) ───────────────────────────────────────────────
export function exportExcel(title, columns, rows) {
  const escape = (v) => {
    const s = String(v ?? "");
    return s.includes(",") || s.includes('"') || s.includes("\n")
      ? `"${s.replace(/"/g, '""')}`
      : s;
  };
  const csv = [columns, ...rows].map((r) => r.map(escape).join(",")).join("\n");
  const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
  const url  = URL.createObjectURL(blob);
  const a    = document.createElement("a");
  a.href     = url;
  a.download = `${title}.csv`;
  a.click();
  URL.revokeObjectURL(url);
}
